<script>
    import icon from '../helpers/icon';

    export default {
        functional: true,
        props: {
            name: {
                required: true,
                type: String,
            },
        },
        render: (createElement, { data, props }) => createElement('i', Object.assign(data, {
            class: `icon icon-${props.name}`,
            domProps: {
                innerHTML: icon(props.name, '', false),
            },
        })),
    };
</script>

<style lang="scss">
    .icon {
        fill: currentColor;

        svg {
            width: 1em;
            height: 1em;
        }
    }
</style>
